import React from 'react';
import { media, Flex } from 'lib/style-utils';
import List from 'react-icons/lib/fa/th-large';

const Wrapper = Flex.extend`
    position: absolute;
    left: 72px;
    top: calc(100vh - 80px);
    background-color: #FFFFFF;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: solid 1px #eeeeee;
    z-index: 20;

    &:hover {
        background-color: #eeeeee;
    }
    &:active {
        background-color: #f2f2f2;
    }

    ${media.w1200`
        left: 40px;
    `}
    ${media.tablet`
        top: calc(100vh - 120px);
    `}
    ${media.mobile`
        left: 10px;
    `}
    ${media.iphone67p`
        top: 570px;
    `}
    ${media.iphone67`
        top: 500px;
    `}
`;

const style = {
    fontSize: '20px',
    color: '#bbbbbb'
}
const ListIcon = ({onClick}) => (
    <Wrapper onClick={onClick}>
        <List style={style}/>
    </Wrapper>
);

export default ListIcon;



// WEBPACK FOOTER //
// ./src/components/Lookbook/ListIcon.js